module.exports = __webpack_public_path__ + "fonts/Roboto-500-greek-ext42.eb17caf.woff2";